var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dialog-base",
    {
      attrs: {
        visible: _vm.visible,
        title: "Điều chỉnh tiền đã thu",
        size: "md",
        "use-panel": false,
        top: "6vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        cancel: _vm.handleClose,
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "sk-dialog__footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-cancel",
                      attrs: { plain: "" },
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v("Hủy")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-save",
                      attrs: { type: "primary", loading: _vm.loading },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v("Lưu")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          staticClass: "sk-dialog-content",
          attrs: {
            model: _vm.dataForm,
            rules: _vm.formRules,
            "label-width": "170px",
            "label-position": "left",
          },
        },
        [
          _c(
            "div",
            { staticClass: "sk-panel mb-4" },
            [
              _c("div", { staticClass: "sk-panel-head" }, [
                _c("div", { staticClass: "sk-panel-icon" }, [
                  _c("i", { staticClass: "el-icon-user" }),
                ]),
                _c("div", [
                  _c("p", { staticClass: "sk-panel-title" }, [
                    _vm._v("Thông tin học sinh"),
                  ]),
                  _c("p", { staticClass: "sk-panel-subtitle" }, [
                    _vm._v("Điều chỉnh số tiền đã thu của phiếu thu nháp"),
                  ]),
                ]),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-form-item", { attrs: { label: "Họ tên" } }, [
                        _c("div", { staticClass: "cmd-readonly" }, [
                          _vm._v(_vm._s(_vm.dataForm.fullName || "-")),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-form-item", { attrs: { label: "Mã học sinh" } }, [
                        _c("div", { staticClass: "cmd-readonly" }, [
                          _vm._v(_vm._s(_vm.dataForm.kidsCode || "-")),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "sk-panel" },
            [
              _c("div", { staticClass: "sk-panel-head" }, [
                _c(
                  "div",
                  { staticClass: "sk-panel-icon sk-panel-icon--success" },
                  [_c("i", { staticClass: "el-icon-money" })]
                ),
                _c("div", [
                  _c("p", { staticClass: "sk-panel-title" }, [
                    _vm._v("Dữ liệu thanh toán"),
                  ]),
                  _c("p", { staticClass: "sk-panel-subtitle" }, [
                    _vm._v(
                      "Nhập tiền mặt/chuyển khoản, hệ thống tự tính tiền đã thu"
                    ),
                  ]),
                ]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "Tiền phải thu" } },
                [
                  _c("el-currency-input", {
                    attrs: { options: _vm.currencyOptions, disabled: true },
                    model: {
                      value: _vm.dataForm.sumMoney,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "sumMoney", $$v)
                      },
                      expression: "dataForm.sumMoney",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Thiếu/Thừa trước", prop: "beforeMoney" } },
                [
                  _c("el-currency-input", {
                    attrs: { options: _vm.currencyOptions },
                    on: { input: _vm.recalculate },
                    model: {
                      value: _vm.dataForm.beforeMoney,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "beforeMoney", $$v)
                      },
                      expression: "dataForm.beforeMoney",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Tiền mặt", prop: "cashMoney" } },
                [
                  _c("el-currency-input", {
                    attrs: { options: _vm.currencyOptions },
                    on: { input: _vm.recalculate },
                    model: {
                      value: _vm.dataForm.cashMoney,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "cashMoney", $$v)
                      },
                      expression: "dataForm.cashMoney",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Chuyển khoản", prop: "transferMoney" } },
                [
                  _c("el-currency-input", {
                    attrs: { options: _vm.currencyOptions },
                    on: { input: _vm.recalculate },
                    model: {
                      value: _vm.dataForm.transferMoney,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "transferMoney", $$v)
                      },
                      expression: "dataForm.transferMoney",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Tiền đã thu" } },
                [
                  _c("el-currency-input", {
                    attrs: { options: _vm.currencyOptions, disabled: true },
                    model: {
                      value: _vm.dataForm.collectedMoney,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "collectedMoney", $$v)
                      },
                      expression: "dataForm.collectedMoney",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label:
                      _vm.dataForm.afterMoney < 0
                        ? "Số tiền còn thiếu"
                        : "Số tiền còn thừa",
                  },
                },
                [
                  _c("el-currency-input", {
                    attrs: { options: _vm.currencyOptions, disabled: true },
                    model: {
                      value: _vm.afterMoneyAbs,
                      callback: function ($$v) {
                        _vm.afterMoneyAbs = $$v
                      },
                      expression: "afterMoneyAbs",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Xử lý thiếu/thừa" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.dataForm.transactionEntry,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataForm, "transactionEntry", $$v)
                        },
                        expression: "dataForm.transactionEntry",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "MONEY_WALLET" } }, [
                        _vm._v("Không chuyển"),
                      ]),
                      _c("el-radio", { attrs: { label: "MONEY_MONTH" } }, [
                        _vm._v("Sang tháng sau"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Ghi chú" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "Nhập ghi chú (nếu có)",
                      maxlength: "500",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.dataForm.note,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "note", $$v)
                      },
                      expression: "dataForm.note",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }